import { render, staticRenderFns } from "./RadioactiveDecayViz.vue?vue&type=template&id=1dde6cec&scoped=true"
import script from "./RadioactiveDecayViz.vue?vue&type=script&lang=js"
export * from "./RadioactiveDecayViz.vue?vue&type=script&lang=js"
import style0 from "./RadioactiveDecayViz.vue?vue&type=style&index=0&id=1dde6cec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde6cec",
  null
  
)

export default component.exports